module.exports = __webpack_public_path__ + "static/media/1.9ad46924.webp";